import InvitationAcceptance from 'src/sections/@dashboard/notifications/components/InvitationAcceptance';
import { useInvitationFlow } from 'src/sections/@dashboard/notifications/components/invitation/useInvitationFlow';

/** Second onboarding step for invited newcomers: decide on the clinic invitation. */
export default function UpdateAccountInvitationStep(): JSX.Element {
  const flow = useInvitationFlow();
  return <InvitationAcceptance {...flow} />;
}
